function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 .5C10.58.5.5 10.58.5 23S10.58 45.5 23 45.5 45.5 35.42 45.5 23 35.42.5 23 .5ZM23 41c-9.922 0-18-8.078-18-18 0-9.923 8.078-18 18-18 9.923 0 18 8.077 18 18 0 9.922-8.077 18-18 18Zm8.73-26.347L18.5 27.883l-4.23-4.23a2.24 2.24 0 0 0-3.173 0 2.24 2.24 0 0 0 0 3.172l5.828 5.828a2.24 2.24 0 0 0 3.172 0l14.828-14.828a2.24 2.24 0 0 0 0-3.172 2.268 2.268 0 0 0-3.195 0Z",
  fill: "url(#a)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -22,
  y1: 23,
  x2: 23,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.34e29ffb.svg";
export { ForwardRef as ReactComponent };